/**
 * Third-level mega-menu flyout: delayed close + viewport-edge overflow handling.
 *
 * Opening is instant (on pointerenter/focusin). Closing is delayed by CLOSE_DELAY ms so the
 * pointer has time to travel diagonally from the 2nd-level trigger link into the 3rd-level
 * flyout panel without it disappearing mid-movement. CSS :hover / :focus-within (see
 * snippets/mega-menu-list.liquid) still work as an instant-open fallback; this script is what
 * controls the .mega-menu__flyout-parent--open class, which is what actually keeps the flyout
 * visible through the delay.
 */
(function () {
  'use strict';

  var OPEN_SELECTOR = '.mega-menu__flyout-parent--has-children';
  var OPEN_CLASS = 'mega-menu__flyout-parent--open';
  var FLIP_CLASS = 'mega-menu__flyout-parent--flip';
  var CLOSE_DELAY = 300; // ms

  var closeTimers = new WeakMap();

  /** @param {Element} parent */
  function cancelPendingClose(parent) {
    var timeoutId = closeTimers.get(parent);
    if (timeoutId) {
      window.clearTimeout(timeoutId);
      closeTimers.delete(parent);
    }
  }

  /** @param {Element} parent */
  function openFlyout(parent) {
    cancelPendingClose(parent);
    parent.classList.add(OPEN_CLASS);

    var flyout = parent.querySelector(':scope > .mega-menu__flyout-list');
    if (!flyout) return;

    // Recheck fresh every time it opens — the viewport may have been resized since last time.
    parent.classList.remove(FLIP_CLASS);
    var rect = flyout.getBoundingClientRect();
    if (rect.right > window.innerWidth) {
      parent.classList.add(FLIP_CLASS);
    }
  }

  /** @param {Element} parent */
  function scheduleClose(parent) {
    cancelPendingClose(parent);
    var timeoutId = window.setTimeout(function () {
      parent.classList.remove(OPEN_CLASS);
      parent.classList.remove(FLIP_CLASS);
      closeTimers.delete(parent);
    }, CLOSE_DELAY);
    closeTimers.set(parent, timeoutId);
  }

  function bind() {
    document.querySelectorAll(OPEN_SELECTOR).forEach(function (parent) {
      if (parent.hasAttribute('data-flyout-bound')) return;
      parent.setAttribute('data-flyout-bound', 'true');

      // pointerenter/pointerleave (like mouseenter/mouseleave) don't fire on transitions to/from
      // descendant elements, so moving from the trigger link into the flyout panel (a DOM
      // descendant, even though visually positioned elsewhere) does not trigger a leave.
      parent.addEventListener('pointerenter', function () {
        openFlyout(parent);
      });
      parent.addEventListener('pointerleave', function () {
        scheduleClose(parent);
      });

      parent.addEventListener('focusin', function () {
        openFlyout(parent);
      });
      parent.addEventListener('focusout', function (event) {
        // Only schedule a close if focus moved somewhere outside this parent entirely.
        if (event.relatedTarget && parent.contains(event.relatedTarget)) return;
        scheduleClose(parent);
      });
    });
  }

  bind();

  // Re-scan after the Section Rendering API / theme editor hydrates new markup.
  document.addEventListener('shopify:section:load', bind);
})();
